module.exports = __webpack_public_path__ + "img/eric_biel_ocular.3b5433f8.jpg";